var classes = {
  "yearsList": "m_9206547b",
  "yearsListCell": "m_c5a19c7d"
};
export { classes as default };